import * as XLSX from "xlsx";

export async function preview(file) {
  console.log("#-# file", file);
  const fileData = await readFile(file);
  const workbook = XLSX.read(fileData, { type: "array" });
  if (!workbook.Props || workbook.Props.Worksheets < 0) {
    return null;
  }

  const sheet1 = workbook.Sheets[workbook.SheetNames[0]];
  if (!sheet1["!ref"]) return null;
  const range = XLSX.utils.decode_range(sheet1["!ref"]);
  if (!range) return null;

  const res = { columnCount: range.e.c - range.s.c + 1, preview: [] };
  const maxRows = Math.min(5, range.e.r - range.s.r+1 );
  for (let r = range.s.r; r < range.s.r + maxRows; r++) {
    const rowData = [];
    for (let c = range.s.c; c <= range.e.c; c++) {
      const cell_address = { c: c, r: r };
      const cell_ref = XLSX.utils.encode_cell(cell_address);
      const cell = sheet1[cell_ref];
      const cellVal = (cell || {}).v || "";
      rowData.push(cellVal);
    }
    res.preview.push(rowData);
  }
  return res;
}

function readFile(file) {
  return new Promise((res, rej) => {
    var reader = new FileReader();

    try {
      reader.onload = function (e) {
        res(new Uint8Array(e.target.result));
      };
      reader.onerror = function (err) {
        rej(err);
      };
      reader.readAsArrayBuffer(file);
    } catch (ex) {
      rej(ex);
    }
  });
}
